<template>
  <div
    class="picture"
    :class="[
      pictureWrapperClass,
      (catalogWrapper && fileId && !errorImage[fileId] && loadImage[fileId] ? 'catalog-image' : '')
    ]"
    :data-alt="alt"
    :data-title="title"
  >
    <div v-if="catalogWrapper ? (fileId && !errorImage[fileId] && !loadImage[fileId]) : false" class="dot" />
    <picture
      v-if="breakpoints && breakpoints.length > 0 && fileId && !errorImage[fileId]"
      :style="pictureStyle"
      :class="{'lozad': isLazy}"
    >
      <!-- Набор изображений webp -->
      <source
        v-for="(source, i) in imageSources('webp')"
        :key="`${source.fileId}webp${i}`"
        :media="source.maxWidth && `(max-width: ${source.maxWidth}px)`"
        type="image/webp"
        :srcset="source.srcset"
        :sizes="source.sizes"
        :width="imgWidth"
        :height="imgHeight"
        :loading="loading"
      >
      <!-- Набор изображений jpg -->
      <source
        v-for="(source, i) in imageSources('jpg')"
        :key="`${source.fileId}jpg${i}`"
        :media="source.maxWidth && `(max-width: ${source.maxWidth}px)`"
        type="image/jpg"
        :srcset="source.srcset"
        :sizes="source.sizes"
        :width="imgWidth"
        :height="imgHeight"
        :loading="loading"
      >
      <!-- Резервное изображение -->
      <img
        v-if="isLazy ? loadImage[fileId] : !isLazy"
        :srcset="imageSrcSet('jpg')"
        :sizes="imageSizes()"
        :src="imagePath('jpg')"
        :alt="alt"
        :title="title"
        :class="imgClasses"
        :style="`${imgStyles};`"
        :width="imgWidth"
        :height="imgHeight"
        :loading="loading"
        @error="onError"
        @load="onLoad"
      >
    </picture>
    <picture
      v-else-if="fileId && !errorImage[fileId]"
      :style="pictureStyle"
      :class="{'lozad': isLazy}"
    >
      <source
        :srcset="imagePath('webp')"
        type="image/webp"
        :width="imgWidth"
        :height="imgHeight"
      >
      <source
        :srcset="imagePath('jpg')"
        type="image/jpg"
        :width="imgWidth"
        :height="imgHeight"
      >
      <img
        v-if="isLazy ? loadImage[fileId] : !isLazy"
        :key="fileId"
        :src="imagePath('jpg')"
        :alt="alt"
        :title="title"
        :class="imgClasses"
        :style="`${imgStyles};`"
        :width="imgWidth"
        :height="imgHeight"
        :loading="loading"
        @error="onError"
        @load="onLoad"
      >
    </picture>
  </div>
</template>

<script>
import { mixins } from 'cms3-shop-module-ts'
export default {
  name: 'UiImage',
  mixins: [mixins.UiImage],
  props: {
    /**
     * * Файл id изображения
     */
    fileData: {
      type: Object,
      default: () => {}
    },
    /**
     * * Тип изображения
     */
    pictureType: {
      type: String,
      default: ''
    },
    /**
     * * Качество изображения
     */
    quality: {
      type: Number,
      default: 100
    },
    /**
     * * Получаем описание изображения
     */
    alt: {
      type: String,
      default: ''
    },
    /**
     * * Получаем заголовок изображения
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * * Получаем стили для изображения
     */
    pictureStyle: {
      type: String,
      default: ''
    },
    /**
     * * Получаем классы для картинки
     */
    imgClasses: {
      type: String,
      default: ''
    },
    /**
     * * Получаем стили для картинки
     */
    imgStyles: {
      type: String,
      default: ''
    },
    /**
     * * Фикс ширина изображения
     */
    imgWidth: {
      type: String,
      default: ''
    },
    /**
     * * Фикс высота изображения
     */
    imgHeight: {
      type: String,
      default: ''
    },
    catalogWrapper: {
      type: Boolean,
      default: false
    },
    /**
     * * Как загружать изображение
     * ? lazy || eager
     */
    loading: {
      type: String,
      default: 'lazy'
    },
    /**
     * * набор точек для адаптивных изображений
     */
    breakpoints: {
      type: Array,
      default: () => { return [] }
    },
    pictureWrapperClass: {
      type: String,
      default: () => ''
    }
  }
}
</script>
